import iconFile from '../../assets/images/icon_data.gif';
import { ItemDataSubTypes } from '../../lib/ItemUtil';
import TopBase, { type TopBaseProps } from '../lib/TopBase';

class DataTop extends TopBase {
    constructor(props: TopBaseProps) {
        super(props);
        this.type = 'data';
        this.label = 'Data';
        this.icon = iconFile;
        this.description =
            '[en]Experimental data, Numerical data/Image/Movie/etc...[/en][ja]実験結果の数値データ/画像/動画など[/ja]';
        this.subTypes = ItemDataSubTypes;
    }
}

export default DataTop;
